import React from 'react';
import { Image, Text, View } from '@react-pdf/renderer';
import { usePdfStyles } from './PdfPrintScaleContext';

/** @param {{ lines: Array<{ name: string; description?: string; imageUrl?: string; sku: string; qty: number }> }} props */
export function NoteLinesPdfTable({ lines }) {
    const pdfStyles = usePdfStyles();
    return (
        <View style={pdfStyles.table}>
            <View style={pdfStyles.tableHead} fixed>
                <Text style={[pdfStyles.thNoteItem, { fontWeight: 'bold' }]}>Item</Text>
                <Text style={[pdfStyles.thNoteSku, { fontWeight: 'bold' }]}>SKU</Text>
                <Text style={[pdfStyles.thNoteQty, { fontWeight: 'bold' }]}>Qty</Text>
            </View>
            {(lines || []).map((ln, idx) => (
                <View
                    style={[pdfStyles.tableRow, { alignItems: 'flex-start' }]}
                    key={`${ln.sku}-${idx}`}
                    wrap={false}
                >
                    <View style={[pdfStyles.itemCell, pdfStyles.thNoteItem]}>
                        {ln.imageUrl ? (
                            <Image src={ln.imageUrl} style={pdfStyles.itemThumb} />
                        ) : (
                            <View style={pdfStyles.itemThumbPlaceholder} />
                        )}
                        <View style={pdfStyles.itemTextCol}>
                            <Text style={pdfStyles.itemName}>{ln.name}</Text>
                            {ln.description ? (
                                <Text style={pdfStyles.itemDesc}>{ln.description}</Text>
                            ) : null}
                        </View>
                    </View>
                    <Text style={[pdfStyles.thNoteSku, pdfStyles.tdMuted]}>{ln.sku}</Text>
                    <Text style={[pdfStyles.thNoteQty, { marginTop: 2 }]}>{String(ln.qty)}</Text>
                </View>
            ))}
        </View>
    );
}
